/**
 * Reduce an object to a select number of specified properties
 *
 * @param  object
 * @param  keys
 */
export const pick = (object: any, keys: string[]) => {
    if (!object || !keys) {
        return {};
    }

    return keys.reduce((acc: any, key) => {
        if (key in object) {
            acc[key] = object[key];
        }

        return acc;
    }, {});
};

/**
 * Walks through the nested properties of an object to check if all the properties
 * are defined and have a value
 *
 * @param properties - Properties to access, in order of depth
 *   eg. If properties are ['a', 'b', 'c'], a valid object would be object = { 'a': { 'b': { 'c': {}}}}
 *
 * @param object - The object that contains the properties to be checked
 *
 * @returns The same object that was passed as an argument gets
 * returned or a value of null is returned if some of the properties weren't defined
 * on the object
 */
export function get<T, U>(properties: string[], object: T): U | null {
    return properties.reduce(
        (accumulator: any, currentProperty: any) =>
            accumulator && accumulator[currentProperty] ? accumulator[currentProperty] : null,
        object,
    );
}
